// Pure decision logic for the "charge the 24h penalty?" prompt shown when a
// coach saves an edited booking. Extracted from EditBooking so it can be unit
// tested without rendering the page.
//
// The `chargePenalty` flag only has an effect on the backend when a participant
// is removed LESS than 24h before a GROUP lesson starts: at >= 24h a credit is
// granted regardless, and single "LESSON" bookings ignore the flag entirely.
// So the prompt is shown only in the case where the answer actually matters.

const HOURS_BEFORE_EVENT_THRESHOLD = 24;

// IDs that were participating before the edit but are no longer in the
// current selection.
export const getRemovedParticipantIds = (
  originalParticipantUserIds = [],
  selectedAthletes = [],
) =>
  originalParticipantUserIds.filter(
    (id) => !selectedAthletes.some((athlete) => athlete.userId === id),
  );

// Human-readable names for the removed IDs (falls back to the raw id).
export const getRemovedNames = (removedIds = [], originalParticipants = []) =>
  removedIds
    .map(
      (id) => originalParticipants.find((p) => p.userId === id)?.fullName || id,
    )
    .join(", ");

// Returns everything the page needs to decide whether (and how) to prompt.
export const computePenaltyPrompt = ({
  originalParticipantUserIds = [],
  originalParticipants = [],
  selectedAthletes = [],
  fromSeconds,
  type,
  now = Date.now(),
}) => {
  const removedParticipantIds = getRemovedParticipantIds(
    originalParticipantUserIds,
    selectedAthletes,
  );

  const hoursBeforeEvent =
    typeof fromSeconds === "number"
      ? (fromSeconds - now / 1000) / 3600
      : Infinity;
  const isGroupLesson = type !== "LESSON";

  const askPenaltyOnSave =
    isGroupLesson &&
    hoursBeforeEvent < HOURS_BEFORE_EVENT_THRESHOLD &&
    removedParticipantIds.length > 0;

  return {
    removedParticipantIds,
    lateRemovedNames: getRemovedNames(
      removedParticipantIds,
      originalParticipants,
    ),
    askPenaltyOnSave,
  };
};
